module.exports = __webpack_public_path__ + "static/media/banner_420x230_17.3830ed45.jpg";